<router-outlet></router-outlet>
<ats-agree-terms></ats-agree-terms>
<ats-support-button></ats-support-button>
